module.exports = __webpack_public_path__ + "static/media/D546GriffinStNW_2018-06-05_12.20a394e4.jpg";